import React, { useState } from "react";
import { Colors } from "../utils/style";
import {
  Button,
  Card,
  Col,
  Container,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";
import Placeholder from "react-bootstrap/Placeholder";
import CardComponent from "./CardComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClone } from "@fortawesome/free-solid-svg-icons";
import { useStore } from "../store";
import axios from "axios";
import "./style.css";
import TableComponent from "./TableComponent";
import DynamicForm from "./dynamicForm";
import ReactMarkdown from 'react-markdown';
import { useTranslation } from 'react-i18next';
import i18n from "../i18n";
import CreditModal from "./CreditModal";
import { axiosInstance } from "../App";

interface Props {
  fileName: string | null;
}

function PredictiveContainer(props: Props) {
  const { summary, setSummary } = useStore();
  const { creditRiskTarget, setCreditRiskTarget } = useStore();

  const [loading, setLoading] = useState(false);
  const [predictionLoading, setPredictionLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { train, setTrain } = useStore();

  const { prediction, setPrediction } = useStore();

  const [index, setIndex] = useState(0);
  const { t } = useTranslation("PredictiveContainer");

  const handleSelect = (selectedIndex: number) => {
    setIndex(selectedIndex);
  };

  function getTrain(target: string, usecase: string, features: string[]) {
    const body = {
      summary: summary,
      target: target,
      features: features,
      usecase: usecase,
    };
    setLoading(true);
    setTrain(null);
    axiosInstance
      .post(process.env.REACT_APP_API_HOST + "classification/train", body, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("tokenLida"),
          "Accept-Language": i18n.language, // Add current language
        },
      })
      .then((response) => {
        setTrain(response.data?.analysis);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error uploading file:", error);

        if (error.response && error.response.status === 402) {
          // Show payment modal
          setIsModalOpen(true);
        }
      });
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "1rem",
          }}
          className="mt-3"
        >
          <FontAwesomeIcon icon={faClone} size="2x" color={Colors.DARK_BLUE} />
          <div
            style={{
              textAlign: "left",
              fontSize: "25px",
              fontWeight: "bold",
              color: Colors.DARK_BLUE,
            }}
          >
            {t("PredictiveAnalysis")}
          </div>
        </div>
        <div
          style={{
            textAlign: "left",
            fontSize: "18px",
            color: Colors.DARK_BLUE,
          }}
        >
          {
            t("PredictiveAnalysisDescription")
          }
        </div>
        <div>
          <CardComponent backgroundColor={Colors.LIGHT_BLUE}>
            <div
              style={{
                display: "flex",
                gap: "3rem",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                onClick={() =>
                  getTrain(
                    creditRiskTarget,
                    "CreditRisk",
                    summary
                      ? summary?.field_names?.filter(
                          (p) => p != creditRiskTarget
                        )
                      : []
                  )
                }
              >
                {t("TrainButton")}
              </Button>
              {/* <MyDropDown
              onClick={getAnalyse}
              options={summary?.field_names}
              title="Select a Target"
            ></MyDropDown> */}
            </div>
            {loading ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "1rem",
                  padding: "1rem",
                }}
              >
                <Spinner animation="grow" variant="success" />

                <div style={{ width: "100%" }}>
                  <div>
                    <Placeholder as={Card.Text} animation="wave">
                      <Placeholder xs={12} />
                      <Placeholder xs={12} />
                      <Placeholder xs={12} />
                      <Placeholder xs={12} />
                      <Placeholder xs={12} />
                      <Placeholder xs={12} />
                      <Placeholder xs={12} />
                    </Placeholder>
                  </div>
                </div>
              </div>
            ) : (
              train && (
                <Container
                  style={{
                    paddingLeft: "2.5rem",
                    paddingRight: "2.5rem",
                    paddingTop: "0.5rem",
                    paddingBottom: "2.5rem",
                  }}
                >
                  <Row md={1} xs={1} lg={1} sm={1}>
                    <Col style={{ padding: "0.5rem" }}>
                      <CardComponent
                        title={t("ModelTrained")}
                        description={t("ModelDescription")}
                      ></CardComponent>
                    </Col>
                    <Col style={{ padding: "0.5rem" }}>
                      <CardComponent title={t("GraphFeatureImportance")}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            maxHeight: "50rem",
                          }}
                        >
                          <div
                            style={{
                              overflowX: "auto",
                            }}
                          >
                            {train && (
                              <img
                                src={`data:image/jpeg;base64, ${train?.graphs?.featureImportance}`}
                              />
                            )}
                          </div>
                        </div>
                      </CardComponent>
                    </Col>
                    <Col style={{ padding: "0.5rem" }}>
                      <CardComponent
                        title={t("GraphAnalysis")}
                        description={train?.analysis?.featureImportance}
                      ></CardComponent>
                    </Col>

                    <Col style={{ padding: "0.5rem" }}>
                      <CardComponent title={t("GraphROC")}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            maxHeight: "50rem",
                          }}
                        >
                          <div
                            style={{
                              overflowX: "auto",
                            }}
                          >
                            {train && (
                              <img
                                src={`data:image/jpeg;base64, ${train?.graphs?.ROC}`}
                              />
                            )}
                          </div>
                        </div>
                      </CardComponent>
                    </Col>
                    <Col style={{ padding: "0.5rem" }}>
                      <CardComponent
                        title={t("ROCAnalysis")}
                        description={train?.analysis?.ROC}
                      ></CardComponent>
                    </Col>
                  </Row>
                  <Row>
                    <Col style={{ padding: "0.5rem" }}>
                      <CardComponent title={t("MetricsSize")}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            maxHeight: "40rem",
                          }}
                        >
                          <div
                            style={{
                              overflowX: "auto",
                            }}
                          >
                            {train && (
                              <TableComponent
                                headers={Object.keys(
                                  train?.metrics?.size as Object
                                )}
                                data={{ size: train?.metrics?.size }}
                              ></TableComponent>
                            )}
                          </div>
                        </div>
                      </CardComponent>
                    </Col>
                    <Col style={{ padding: "0.5rem" }} slot="2">
                      <CardComponent
                        title={t("SizeAnalysis")}
                        description={train?.analysis?.size}
                      ></CardComponent>
                    </Col>
                  </Row>
                  <Row md={1} xs={1} lg={1} sm={1}>
                    <Col style={{ padding: "0.5rem" }}>
                      <CardComponent
                        title={t("MetricsBinaryClassification")}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <div
                            style={{
                              overflowX: "auto",
                            }}
                          >
                            <TableComponent
                              headers={Object.keys(
                                train?.metrics?.binaryClassificationMetrics
                                  ?.confusionMatrix as Object
                              )}
                              data={{
                                Confusion_Matrix:
                                  train?.metrics?.binaryClassificationMetrics
                                    ?.confusionMatrix,
                              }}
                            ></TableComponent>
                          </div>
                          <div
                            style={{
                              overflowX: "auto",
                            }}
                          >
                            <TableComponent
                              headers={Object.keys(
                                train?.metrics
                                  ?.binaryClassificationMetrics as Object
                              ).filter((key) => key != "confusionMatrix")}
                              data={{
                                Metrics: {
                                  precision:
                                    train?.metrics?.binaryClassificationMetrics
                                      ?.precision,
                                  F1Score:
                                    train?.metrics?.binaryClassificationMetrics
                                      ?.F1Score,
                                  accuracy:
                                    train?.metrics?.binaryClassificationMetrics
                                      ?.accuracy,
                                  recall:
                                    train?.metrics?.binaryClassificationMetrics
                                      ?.recall,
                                  specificity:
                                    train?.metrics?.binaryClassificationMetrics
                                      ?.specificity,
                                },
                              }}
                            ></TableComponent>
                          </div>
                        </div>
                      </CardComponent>
                    </Col>
                    <Col style={{ padding: "0.5rem" }} slot="2">
                      <CardComponent
                        title={t("BinaryClassificationAnalysis")}
                        description={
                          train?.analysis?.binaryClassificationMetrics
                        }
                      ></CardComponent>
                    </Col>
                  </Row>
                </Container>
              )
            )}
          </CardComponent>
        </div>
      </div>

      {train && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "1rem",
            }}
            className="mt-3"
          >
            <FontAwesomeIcon
              icon={faClone}
              size="2x"
              color={Colors.DARK_BLUE}
            />
            <div
              style={{
                textAlign: "left",
                fontSize: "25px",
                fontWeight: "bold",
                color: Colors.DARK_BLUE,
              }}
            >
              {t("Prediction")}
            </div>
          </div>
          <div
            style={{
              textAlign: "left",
              fontSize: "18px",
              color: Colors.DARK_BLUE,
            }}
          >
            {
              t("PredictionDescription")
            }
          </div>
          <div>
            <CardComponent backgroundColor={Colors.LIGHT_BLUE}>
              <Container
                style={{
                  paddingLeft: "2.5rem",
                  paddingRight: "2.5rem",
                  paddingTop: "0.5rem",
                  paddingBottom: "2.5rem",
                }}
              >
                <Row md={1} xs={1} lg={1} sm={1}>
                  <Col style={{ padding: "0.5rem" }}>
                    <CardComponent title={t("MakePredictions")}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          maxHeight: "50rem",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            overflowX: "auto",
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <div
                            style={{
                              maxWidth: "30rem",
                              width: "100%",
                            }}
                          >
                            <DynamicForm
                              fields={train.fields}
                              setPrediction={setPrediction}
                              setPredictionLoading={setPredictionLoading}
                            />
                          </div>
                        </div>
                      </div>
                    </CardComponent>
                  </Col>
                </Row>

                {predictionLoading ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "1rem",
                      padding: "1rem",
                    }}
                  >
                    <Spinner animation="grow" variant="success" />

                    <div style={{ width: "100%" }}>
                      <div>
                        <Placeholder as={Card.Text} animation="wave">
                          <Placeholder xs={12} />
                          <Placeholder xs={12} />
                          <Placeholder xs={12} />
                          <Placeholder xs={12} />
                          <Placeholder xs={12} />
                          <Placeholder xs={12} />
                          <Placeholder xs={12} />
                        </Placeholder>
                      </div>
                    </div>
                  </div>
                ) : (
                  prediction && (
                    <>
                      <Row md={1} xs={1} lg={1} sm={1}>
                        <Col style={{ padding: "0.5rem" }}>
                          <CardComponent
                            title={t("Message")}
                            description={
                              prediction?.prediction?.explanation?.message
                            }
                          ></CardComponent>
                        </Col>
                      </Row>
                      <Row md={1} xs={1} lg={1} sm={1}>
                        <Col style={{ padding: "0.5rem" }}>
                          <CardComponent title={t("Output")}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                maxHeight: "50rem",
                                width: "100%",
                              }}
                            >
                              <div
                                style={{
                                  overflowX: "auto",
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <div
                                  style={{
                                    maxWidth: "30rem",
                                    width: "100%",
                                  }}
                                >
                                  <Table striped bordered hover>
                                    <thead>
                                      <tr>
                                        <th>{t("ProbabilityOfPayment")}</th>
                                        <th>
                                          {t("ProbabilityOfDefault")}
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        {prediction?.prediction?.probability?.map(
                                          (p) => (
                                            <td>{p}</td>
                                          )
                                        )}
                                      </tr>
                                    </tbody>
                                  </Table>
                                </div>
                              </div>
                            </div>
                          </CardComponent>
                        </Col>
                      </Row>
                      <Row md={1} xs={1} lg={1} sm={1}>
                        <Col style={{ padding: "0.5rem" }}>
                          <CardComponent title={t("WaterfallChart")}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                maxHeight: "50rem",
                              }}
                            >
                              <div
                                style={{
                                  overflowX: "auto",
                                }}
                              >
                                {prediction && (
                                  <img
                                    src={`data:image/jpeg;base64, ${prediction.prediction?.explanation?.waterfallChart}`}
                                  />
                                )}
                              </div>
                            </div>
                          </CardComponent>
                        </Col>
                      </Row>
                      <Row md={1} xs={1} lg={1} sm={1}>
                        <Col style={{ padding: "0.5rem" }}>
                          <CardComponent
                            title={t("GeneralExplanation")}
                            description={
                              prediction?.prediction?.explanation?.waterfall
                                ?.generalExplanation
                            }
                          ></CardComponent>
                        </Col>
                      </Row>
                      <Row md={1} xs={1} lg={1} sm={1}>
                        <Col style={{ padding: "0.5rem" }}>
                          <CardComponent
                            title={t("FeaturesBreakdown")}
                            description={
                              prediction?.prediction?.explanation?.waterfall
                                ?.featuresBreakdown
                            }
                          ></CardComponent>
                        </Col>
                      </Row>
                    </>
                  )
                )}
              </Container>
            </CardComponent>
          </div>
        </div>
      )}


    </>
  );
}

export default PredictiveContainer;
